/* Supratec cart drawer (adapted from DAR cmx-mini-cart).
   Pixel-safe: never adds to cart by itself. The theme's native <product-form>
   adds the item; this drawer replaces the theme's cart-notification UI. */
(function () {
  'use strict';
  var drawer = document.getElementById('SpCart');
  var overlay = document.getElementById('SpCartOverlay');
  if (!drawer || !overlay) return;

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('SpCartConfig').textContent); } catch (e) { cfg = { t: {} }; }
  var T = cfg.t || {};
  var $ = function (sel) { return drawer.querySelector(sel); };
  var itemsEl = $('[data-sp-cart-items]');
  var footEl = $('[data-sp-cart-foot]');
  var emptyEl = $('[data-sp-cart-empty]');
  var crossEl = $('[data-sp-cart-cross]');
  var crossTrack = $('[data-sp-cart-cross-track]');
  var shipEl = $('[data-sp-cart-ship]');
  var scrollEl = $('[data-sp-cart-scroll]');
  var lastFocus = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    if (typeof window.spFormatMoney === 'function') return window.spFormatMoney(cents);
    var v = (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v.join('.');
  }
  function esc(s) { var d = document.createElement('div'); d.appendChild(document.createTextNode(s == null ? '' : String(s))); return d.innerHTML; }
  function sized(url, size) { return url ? url.replace(/(\.\w+)(\?|$)/, '_' + size + '$1$2') : ''; }

  /* ---------- open / close ---------- */
  function show() {
    lastFocus = document.activeElement;
    overlay.hidden = false; drawer.hidden = false;
    void drawer.offsetHeight;
    overlay.classList.add('is-open'); drawer.classList.add('is-open');
    document.documentElement.classList.add('sp-cart-lock');
    var close = drawer.querySelector('.sp-cart__close');
    if (close) close.focus({ preventScroll: true });
  }
  function hide() {
    overlay.classList.remove('is-open'); drawer.classList.remove('is-open');
    document.documentElement.classList.remove('sp-cart-lock');
    setTimeout(function () { overlay.hidden = true; drawer.hidden = true; }, reduceMotion ? 0 : 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function fetchCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function open() { return fetchCart().then(function (c) { render(c); show(); }).catch(show); }
  function refresh() { return fetchCart().then(render); }

  /* ---------- render ---------- */
  function updateCounts(n) {
    drawer.querySelectorAll('[data-sp-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('#cart-notification-count, .header__actions_btn--cart .cart-count-bubble > span[aria-hidden]').forEach(function (el) { el.textContent = n; });
  }

  function renderShipping(cart) {
    if (!shipEl || !cfg.threshold) return;
    var total = cart.total_price, goal = cfg.threshold;
    var pct = Math.min(100, Math.round(total / goal * 100));
    var text = shipEl.querySelector('[data-sp-cart-ship-text]');
    var bar = shipEl.querySelector('[data-sp-cart-bar]');
    var fill = shipEl.querySelector('[data-sp-cart-bar-fill]');
    shipEl.hidden = cart.item_count === 0;
    if (total >= goal) {
      shipEl.classList.add('is-unlocked');
      text.textContent = T.free_unlocked || '';
    } else {
      shipEl.classList.remove('is-unlocked');
      text.innerHTML = esc(T.free_remaining || '').replace('[amount]', '<b>' + esc(money(goal - total)) + '</b>');
    }
    fill.style.width = pct + '%';
    bar.setAttribute('aria-valuenow', pct);
  }

  function render(cart) {
    updateCounts(cart.item_count);
    renderShipping(cart);
    if (scrollEl) scrollEl.hidden = cart.item_count === 0;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      footEl.hidden = true; crossEl.hidden = true; emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true; footEl.hidden = false;
    $('[data-sp-cart-subtotal]').textContent = money(cart.total_price);

    var saved = cart.total_discount || 0;
    if (!saved) cart.items.forEach(function (it) { if (it.original_line_price > it.final_line_price) saved += it.original_line_price - it.final_line_price; });
    var savedEl = $('[data-sp-cart-saved]');
    savedEl.hidden = !(saved > 0);
    if (saved > 0) savedEl.textContent = (T.saved || '').replace('[amount]', money(saved));

    var html = '';
    cart.items.forEach(function (it) {
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="sp-cart-item__variant">' + esc(it.variant_title) + '</span>' : '';
      var old = it.original_line_price > it.final_line_price ? '<s class="sp-cart-item__old">' + esc(money(it.original_line_price)) + '</s>' : '';
      var props = '';
      if (it.properties) Object.keys(it.properties).forEach(function (k) { if (it.properties[k] && k.charAt(0) !== '_') props += '<span>' + esc(k) + ': ' + esc(it.properties[k]) + '</span>'; });
      html += '<div class="sp-cart-item" data-key="' + esc(it.key) + '">' +
        '<a class="sp-cart-item__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(sized(it.image, '200x200')) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="sp-cart-item__info">' +
          '<a class="sp-cart-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + vt +
          (props ? '<span class="sp-cart-item__props">' + props + '</span>' : '') +
          '<div class="sp-cart-item__row">' +
            '<div class="sp-cart-item__qty">' +
              '<button type="button" data-action="minus" aria-label="' + esc(T.decrease || '-') + '">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-action="plus" aria-label="' + esc(T.increase || '+') + '">+</button>' +
            '</div>' +
            '<div class="sp-cart-item__price">' + esc(money(it.final_line_price)) + old + '</div>' +
          '</div>' +
          '<button type="button" class="sp-cart-item__remove" data-action="remove">' + esc(T.remove || 'Eliminar') + '</button>' +
        '</div></div>';
    });
    itemsEl.innerHTML = html;
    loadCross(cart);
  }

  /* ---------- cross-sell: links to the product page (no custom add to cart) ---------- */
  var crossFor = null;
  function loadCross(cart) {
    var pid = cart.items[0] && cart.items[0].product_id;
    if (!pid) { crossEl.hidden = true; return; }
    if (crossFor === pid + ':' + cart.item_count) return;
    crossFor = pid + ':' + cart.item_count;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 4);
        if (!prods.length) { crossEl.hidden = true; return; }
        crossTrack.innerHTML = prods.map(function (p) {
          return '<a class="sp-cart-cross" href="' + esc(p.url) + '">' +
            '<span class="sp-cart-cross__img">' + (p.featured_image ? '<img src="' + esc(sized(p.featured_image, '200x200')) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="sp-cart-cross__name">' + esc(p.title) + '</span>' +
            '<span class="sp-cart-cross__price">' + esc(money(p.price)) + '</span>' +
            '<span class="sp-cart-cross__cta">' + esc(T.view_product || '') + '</span></a>';
        }).join('');
        crossEl.hidden = false;
      })
      .catch(function () { crossEl.hidden = true; });
  }

  /* ---------- quantity (same endpoint the theme drawer uses) ---------- */
  function change(key, qty) {
    var row = itemsEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) row.classList.add('is-updating');
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) {
      if (c.status) { alert(c.description || T.error); if (row) row.classList.remove('is-updating'); return; }
      render(c);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
    }).catch(function () { if (row) row.classList.remove('is-updating'); });
  }
  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var row = btn.closest('.sp-cart-item');
    var key = row && row.getAttribute('data-key');
    if (!key) return;
    var q = parseInt(row.querySelector('.sp-cart-item__qty span').textContent, 10) || 0;
    var a = btn.getAttribute('data-action');
    change(key, a === 'plus' ? q + 1 : a === 'minus' ? Math.max(0, q - 1) : 0);
  });

  /* ---------- close triggers ---------- */
  overlay.addEventListener('click', hide);
  drawer.addEventListener('click', function (e) { if (e.target.closest('[data-sp-cart-close]')) hide(); });
  document.addEventListener('keydown', function (e) {
    if (drawer.hidden) return;
    if (e.key === 'Escape') hide();
    if (e.key === 'Tab') {
      var f = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- theme integration ---------- */
  // Header cart icon -> this drawer (except on the cart page itself)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('open-minicart, .header__actions_btn--cart');
    if (!trigger || /\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open();
  }, true);

  // Native add to cart (product-form) calls cart-notification.renderContents(): show this drawer instead
  function patchNative() {
    var C = window.customElements && customElements.get('cart-notification');
    if (!C || C.prototype._spPatched) return;
    C.prototype._spPatched = true;
    C.prototype.renderContents = function () { open(); };
    C.prototype.open = function () { open(); };
  }
  if (window.customElements) {
    patchNative();
    customElements.whenDefined('cart-notification').then(patchNative);
  }
  document.addEventListener('cart:refresh', refresh);

  window.spCart = { open: open, close: hide, refresh: refresh };
})();
